import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Combobox, ComboboxProvider, ComboboxPopover } from '@ariakit/react';
import { forwardRef, useRef } from 'react';
import { styled } from 'styletron-react';
import { sizes } from '../../../const/sizes';
import { zIndexes } from '../../../const/zIndexes';
import { useFloatingSurfaceStyle } from '../../../hooks/useFloatingSurfaceStyle';
import { TextInput } from '../TextInput/TextInput';
import { ComboboxInputItem } from './components/ComboboxInputItem';
const StyledComboboxPopover = styled(ComboboxPopover, (p) => ({
    ...p.$floatingSurfaceStyle,
    width: 'var(--popover-anchor-width)',
    maxHeight: `min(var(--popover-available-height), ${sizes.combobox.maxHeight})`,
    zIndex: zIndexes.combobox,
    overflow: 'auto',
}));
export const ComboboxInput = forwardRef(({ defaultValue, onValueChange, value, onSelect, options, ...props }, ref) => {
    const floatingSurfaceStyle = useFloatingSurfaceStyle();
    const inputWrapperRef = useRef(null);
    const getAnchorRect = () => {
        return inputWrapperRef.current?.getBoundingClientRect() ?? null;
    };
    const hasOptions = options && options.length > 0;
    return (_jsxs(ComboboxProvider, { value: value, setValue: onValueChange, children: [_jsx(Combobox, { render: _jsx(TextInput, { ref: ref, ...props, inputWrapperRef: inputWrapperRef }) }), hasOptions && (_jsx(StyledComboboxPopover, { $floatingSurfaceStyle: floatingSurfaceStyle, getAnchorRect: getAnchorRect, children: options.map((option, index) => {
                    const isLast = index === options.length - 1;
                    const key = option.id ?? option.value;
                    return (_jsx(ComboboxInputItem, { text: option.text, subtext: option.subtext, value: option.value, testId: option.testId, withDivider: !isLast, id: option.id, onSelect: onSelect }, key));
                }) }))] }));
});
ComboboxInput.displayName = 'ComboboxInput';
